export const ZoomConfig = {
  windowHeight: 348,
  windowWidth: 464,
  zoomStep: 1,
  zoomMaxScale: 6,
  zoomInitScale: 1,
  animation: 400,
  modelImageSize: 640,
};
